export const initialState = {
  auth: {
    uid: null,
    message: null,
    auth: false

  },
  document: {
    skinCode: "one",
    header: ""
  },
  contactDetails: {
    fname: "",
    lname: "",
    pSummary: "",
    email: "",
    phone: "",
    hNo: "",
    street: "",
    city: "",
    pin: "",
    state: "",
    country: ""
  },
  educationDetails: {
    cCity: "",
    cName: "",
    cCountry: "",
    degree: "",
    yop: "",
    one: [],
    two: [],
    three: []
  },
  experienceDetails: [
   {
    }
  ]
}